<template>
  <div class="aboutUs">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div class="remind">
      <van-cell center title="交易提醒">
        <template #right-icon>
          <van-switch v-model="info.tradingNotice" size="24" @change="changeInfo" />
        </template>
      </van-cell>
      <van-cell center title="余额不足提醒">
        <template #right-icon>
          <van-switch v-model="info.insufficientBalanceNotice" size="24" @change="changeInfo" />
        </template>
      </van-cell>
      <van-field v-if="info.insufficientBalanceNotice" v-model="info.insufficientBalance" label="提醒额度" placeholder="请输入提醒额度" @blur="changeInfo" />
    </div>
  </div>
</template>

<script>
import { accountEdit, accountInfo } from '@/api/user';

export default {
  data() {
    return {
      subHead: '支付通知',
      info: {}
    };
  },
  created() {
    this.getAccountInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getAccountInfo() {
      accountInfo({}).then(res => {
        if (res.code === 200) {
          this.info = res.data;
          this.payRank = res.data.payRank;
        }
      });
    },
    changeInfo() {
      accountEdit(this.info);
    }
  }
};
</script>

<style lang="less" scoped>
.aboutUs {
  position: relative;
  .content {
    padding: 0rem 0.15rem;
    font-size: 0.14rem;
    .logoInfo {
      display: flex;
      padding: 0.14rem 0rem;
      .logoImg {
        width: 0.48rem;
        height: 0.48rem;
        background: #fff;
        text-align: center;
        padding: 0.07rem;
        margin-right: 0.16rem;
        border-radius: 4px;
        box-sizing: border-box;
        img {
          width: 0.34rem;
        }
      }
      .logoText {
        p:first-child {
          font-size: 0.18rem;
          color: #3b86ff;
          font-weight: bold;
        }
        p:last-child {
          color: rgba(51, 51, 51, 0.5);
        }
      }
    }
    .comIntroduce {
      background: #fff;
      padding: 0.1rem 0.23rem 0rem;
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      color: rgba(51, 51, 51, 0.7);
      p {
        line-height: 0.25rem;
      }
      p:not(:last-child) {
        margin-bottom: 0.25rem;
      }

      hr {
        height: 0px;
        border: 1px #cccccc dotted;
      }
      .tel {
        text-align: center;
        color: #3b86ff;
        height: 0.52rem;
        line-height: 0.52rem;
      }
    }
  }
  //样式要再调
  .footer {
    font-size: 0.1rem;
    color: rgba(51, 51, 51, 0.5);
    text-align: center;
    clear: both;
    display: block;
    margin: 0px auto;
    position: absolute;
    bottom: -2.1rem;
    width: 100%;
  }
}
</style>
